// Panel definitions organized by category and segment key

// Forward category panels
import { forwardCoalPanels, forwardCoalSyncGroups } from './forward/coal';
import { forwardElectricityPanels, forwardElectricitySyncGroups } from './forward/electricity';
import { forwardEmissionsPanels, forwardEmissionsSyncGroups } from './forward/emissions';
import { forwardGasPanels, forwardGasSyncGroups } from './forward/gas';
import { forwardOilPanels, forwardOilSyncGroups } from './forward/oil';

// Flex category panels
import { flexAfrrPanels, flexAfrrSyncGroups } from './flex/afrr';
import { flexBalancingPanels } from './flex/balancing';
import { flexCapturePricePanels } from './flex/capturePrice';
import { flexCbmpPanels, flexCbmpSyncGroups } from './flex/cbmp';
import { flexCongestionPanels, flexCongestionSyncGroups } from './flex/congestion';
import { flexCrossborderPanels, flexCrossborderSyncGroups } from './flex/crossborder';
import { flexDayAheadPanels, flexDayAheadSyncGroups } from './flex/dayAhead';
import { flexFcrPanels, flexFcrSyncGroups } from './flex/fcr';
import { flexGenerationPanels } from './flex/generation';
import { flexImbalancePanels } from './flex/imbalance';
import { flexIntradayPanels, flexIntradaySyncGroups } from './flex/intraday';
import { flexMfrrPanels, flexMfrrSyncGroups } from './flex/mfrr';
import { flexTbSpreadsPanels, flexTbSpreadsSyncGroups } from './flex/tbSpreads';

// Flex category panels (to be implemented)
// import { flexBalancingPanels } from './flex/balancing'
// etc.

export const GRID_COLS = 24;
export const GRID_ROW_HEIGHT = 30;
export const GRID_GAP = 10;

/**
 * Panel registry organized by category and segment key
 *
 * Usage:
 *   const panels = panelRegistry['forward']['oil']
 */
export const panelRegistry = {
  forward: {
    oil: forwardOilPanels,
    coal: forwardCoalPanels,
    emissions: forwardEmissionsPanels,
    gas: forwardGasPanels,
    electricity: forwardElectricityPanels,
  },
  flex: {
    crossborder: flexCrossborderPanels,
    imbalance: flexImbalancePanels,
    intraday: flexIntradayPanels,
    dayAhead: flexDayAheadPanels,
    fcr: flexFcrPanels,
    afrr: flexAfrrPanels,
    mfrr: flexMfrrPanels,
    balancing: flexBalancingPanels,
    capturePrice: flexCapturePricePanels,
    generation: flexGenerationPanels,
    cbmp: flexCbmpPanels,
    congestion: flexCongestionPanels,
    tbSpreads: flexTbSpreadsPanels,
  },
};

export const syncGroupRegistry = {
  forward: {
    oil: forwardOilSyncGroups,
    coal: forwardCoalSyncGroups,
    emissions: forwardEmissionsSyncGroups,
    electricity: forwardElectricitySyncGroups,
    gas: forwardGasSyncGroups,
  },
  flex: {
    dayAhead: flexDayAheadSyncGroups,
    crossborder: flexCrossborderSyncGroups,
    intraday: flexIntradaySyncGroups,
    fcr: flexFcrSyncGroups,
    afrr: flexAfrrSyncGroups,
    mfrr: flexMfrrSyncGroups,
    cbmp: flexCbmpSyncGroups,
    congestion: flexCongestionSyncGroups,
    tbSpreads: flexTbSpreadsSyncGroups,
  },
};

/**
 * Get panels for a specific category/segment combination
 */
export function getPanels(category, segmentKey, options) {
  const categoryPanels = panelRegistry[category];
  if (!categoryPanels) {
    return [];
  }

  const panels = categoryPanels[segmentKey];
  if (!panels) {
    return [];
  }

  if (typeof panels === 'function') {
    return panels(options);
  }

  return panels;
}

export function getSyncGroups(category, segmentKey, options) {
  const categoryGroups = syncGroupRegistry[category];
  if (!categoryGroups) return [];

  const groups = categoryGroups[segmentKey];
  if (!groups) return [];

  if (typeof groups === 'function') {
    return groups(options);
  }

  return groups;
}

/**
 * Get list of available segment keys for a category
 */
export function getCategoryKeys(category) {
  const categoryPanels = panelRegistry[category];
  if (!categoryPanels) return [];

  return Object.keys(categoryPanels);
}
